<div class="piholder">

    <div class="picreation">
        <!-- Filter -->
        <div class="filter">
            <div class="sortview">
                <div class="sortby">
                    
                    <mat-form-field class="example-full-width">
                        <mat-label>Add Name</mat-label>
                        <input matInput placeholder="Add name" value="">
                      </mat-form-field>
        
                </div>
                <!-- <div class="view_list">
                    <button mat-icon-button  [ngClass]="{'active': list}" mat-icon-button (click)="showList()"  ><mat-icon>format_list_bulleted</mat-icon></button>
                    <button mat-icon-button [ngClass]="{'active': grid}" (click)="showGrid()" ><mat-icon>apps</mat-icon></button>       
                </div> -->
            </div>
            <div class="actbtn" >
                <button mat-flat-button disabled color="primary"  >
                    Save as Tempalte
                </button>
                <button mat-flat-button disabled color="primary"  >
                    Save as Draft
                </button>
                <button mat-flat-button  disabled color="primary"  >
                Save
                </button>
            </div>
        </div>
        <!-- Filter -->

        <div class="workspace">

            <div class="toolbox">
                <div class="tools">
                    <div class="tool">
                        <img src="../../../../../../assets/images/icons/start-stop.svg">
                        <p>Start/Stop</p>
                    </div>
                    <div class="tool">
                        <img src="../../../../../../assets/images/icons/step.svg">
                        <p>Step</p>
                    </div>
                    <div class="tool">
                        <img src="../../../../../../assets/images/icons/decision.svg">
                        <p>Decision</p>
                    </div>
                    <div class="tool">
                        <img src="../../../../../../assets/images/icons/document.svg">
                        <p>Document</p>
                    </div>
                    <div class="tool">
                        <img src="../../../../../../assets/images/icons/notes.svg">
                        <p>Notes</p>
                    </div>
                    <div class="tool">
                        <img src="../../../../../../assets/images/icons/addPI.svg">
                        <p>Add PI</p>
                    </div>
                </div>
            </div>

            <div class="work">
                  <!-- Draw here-->  
            </div>

        </div>

    </div>

    <div class="templateholder">
       <div class="head">
        <h3>Templates </h3><span class="count">3</span>
       </div>
       <div class="holder">
           <ul>
               <li>
                   <span>Finance Department</span>
                   <!-- <span class="count">3</span> -->
               </li>
               <li>
                <span>Real Estate</span>
                <!-- <span class="count">11</span> -->
            </li>
           </ul>
       </div>
    </div>

</div>